<template>
  <div class="mobile-navigator"
       :class="modifiers"
  >
    <component v-for="navigatorItem in navigatorItems"
               :key="navigatorItem.id"
               :is="navigatorItem"
               class="mobile-navigator__item"
               @before-toggle="itemBeforeToggle"
    />
  </div>
</template>

<script>
import NavigatorItemMap from "@/components/common/MobileNavigator/NavigatorItemMap.vue";
import NavigatorItemSidebar from "@/components/common/MobileNavigator/NavigatorItemSidebar.vue";
import NavigatorItemRoutes from "@/components/common/MobileNavigator/NavigatorItemRoutes.vue";
import NavigatorItemTimeline from "@/components/common/MobileNavigator/NavigatorItemTimeline.vue";
import rules from "@/config/rules";

export default {
  name: "MobileNavigator",
  components: {
    NavigatorItemMap,
    NavigatorItemSidebar,
    NavigatorItemRoutes,
    NavigatorItemTimeline
  },
  data() {
    return {
      isRoutesEnabled: rules.isFeatureItinerariesEnabled
    }
  },
  computed: {
    navigatorItems() {
      return [
        NavigatorItemSidebar,
        NavigatorItemMap,
        rules.isFeatureItinerariesEnabled ? NavigatorItemRoutes : null,
        NavigatorItemTimeline
      ].filter((item) => !!item)
    },
    isOverlay() {
      return this.$route.name !== 'home'
    },
    modifiers() {
      return {
        'mobile-navigator--is-overlay': this.isOverlay
      }
    }
  },
  methods: {
    itemBeforeToggle() {
      if (this.$route.name !== 'home') {
        this.$router.push({ name: 'home' })
      }
    }
  }
}
</script>

<style lang="scss">
.mobile-navigator {
  display: none;
  position: fixed;
  bottom: $content-padding-bottom;
  left: 0;
  width: 100%;
  justify-content: space-between;
  pointer-events: none;
  z-index: 15;

  &--is-overlay {
    z-index: 30;
  }

  > * {
    pointer-events: all;
  }

  &__item {
    display: flex;
    align-items: center;
    justify-content: center;
    width: $mobile-navigator-item-size;
    height: $mobile-navigator-item-size;
    padding: 20px;
    background-color: $app-block-color;
    box-shadow: 0 2px 4px rgba($app-text-color, .5);
    border: none;
    cursor: pointer;
  }
}

@include smallerThan("lg") {
  .mobile-navigator {
    display: flex;
  }
}

@include smallerThan("md") {
  .mobile-navigator {
    z-index: 30;
  }
}
</style>
